<template>
  <div id="app">
    <header_menu v-if="!flag"></header_menu>
    <headerMenuPhone v-if="flag"></headerMenuPhone>
    <router-view/>
  </div>
</template>
<script>
import header_menu from "@/components/header_menu";
import headerMenuPhone from "@/components/header_menu_phone";
export default {
  components:{
    header_menu,
    headerMenuPhone
  },
  data(){
    return{
      flag:false,
    }
  },
  created(){
    this.flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone|ipad)/i)
  }
}
</script>

<style lang="scss">
body {
  margin: 0;
  min-width: 1330px;
}
</style>
